export default "__VITE_ASSET__Fo9rNOYqWOPqQ1m9HcD3CQ__"